export default __webpack_public_path__ + "static/media/flag-tanzania.54387d20.svg";